import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import './mashup-theme.css';

import { ThemeProvider, useTheme } from './ThemeContext';

// Layout components
import ScrollToTop from './components/ScrollToTop';
import SplashIntro from './components/SplashIntro';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HostessChat from './components/HostessChat';
import PwaInstallBanner from './components/PwaInstallBanner';
import LiveDonationToast from './components/LiveDonationToast';
import SponsorTicker from './components/SponsorTicker';
import RetroNostalgia from './components/RetroNostalgia';
import FloatingQuiz from './components/FloatingQuiz';

// Pages (refactored)
import HomePage from './pages/HomePage';
import HubPage from './pages/HubPage';
import SedePage from './pages/SedePage';
import FormazionePage from './pages/FormazionePage';
import BrandPage from './pages/BrandPage';
import DonaPage from './pages/DonaPage';
import ContattiPage from './pages/ContattiPage';
import CittadinoPage from './pages/CittadinoPage';
import RecapPage from './pages/RecapPage';
import AllAboutUsPage from './pages/AllAboutUsPage';
import LinksPage from './pages/LinksPage';
import ChiantiBancaPage from './pages/ChiantiBancaPage';

import DoposcuolaPage from './pages/DoposcuolaPage';
import ArtistigianatoPage from './pages/ArtistigianatoPage';
import ABTestPage from './pages/ABTestPage';
import VersioneStanfordPage from './pages/VersioneStanfordPage';
import VersioneGovPage from './pages/VersioneGovPage';
import VersioneMashupPage from './pages/VersioneMashupPage';

// Pages (already separate files)
import PitchPage from './PitchPage';
import EmailPage from './EmailPage';
import VideoPage from './VideoPage';
import TshirtGalleryPage from './TshirtGalleryPage';
import AdminPage from './AdminPage';
import PodcastPage from './pages/PodcastPage';
import GenerazioniPage from './pages/GenerazioniPage';
import MentorPage from './pages/MentorPage';
import ArchivioDigitalePage from './pages/ArchivioDigitalePage';
import SocialPage from './pages/SocialPage';
import StrategiaPage from './pages/StrategiaPage';
import CrowdfundingPage from './pages/CrowdfundingPage';
import AngelsPage from './pages/AngelsPage';
import UtilityPage from './pages/UtilityPage';

// Axios defaults
axios.defaults.timeout = 15000;

import ThemeChooser from './components/ThemeChooser';

function AppContent() {
  const [splashDone, setSplashDone] = useState(false);
  const [themeChosen, setThemeChosen] = useState(() => sessionStorage.getItem('ai_covo_theme_chosen') === '1');
  const { themeClass, isInstitutional } = useTheme();
  const location = useLocation();

  const isFormazione = location.pathname === '/formazione';
  const activeThemeClass = isInstitutional
    ? (isFormazione ? 'theme-gov' : 'theme-mashup')
    : '';

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* A/B Test pages — standalone, no dark shell */}
        <Route path="/test-ab" element={<ABTestPage />} />
        <Route path="/versione-a" element={<VersioneStanfordPage />} />
        <Route path="/versione-b" element={<VersioneGovPage />} />
        <Route path="/versione-c" element={<VersioneMashupPage />} />

        {/* Main site — themed */}
        <Route path="/*" element={
          <>
            {!splashDone && (
              <SplashIntro onComplete={() => setSplashDone(true)} />
            )}
            {splashDone && !themeChosen && (
              <ThemeChooser onComplete={() => { sessionStorage.setItem('ai_covo_theme_chosen', '1'); setThemeChosen(true); }} />
            )}
            <div
              data-testid="app-shell"
              className={`min-h-screen ${
                isInstitutional ? '' : 'bg-[#050505] text-white'
              } ${activeThemeClass} ${splashDone && themeChosen ? '' : 'opacity-0'}`}
              style={{ transition: 'opacity 0.5s ease-in' }}
            >
              <Navigation />
              {!isInstitutional && <RetroNostalgia />}
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/hub" element={<HubPage />} />
                <Route path="/sede" element={<SedePage />} />
                <Route path="/formazione" element={<FormazionePage />} />
                <Route path="/brand" element={<BrandPage />} />
                <Route path="/dona" element={<DonaPage />} />
                <Route path="/contatti" element={<ContattiPage />} />
                <Route path="/pitch" element={<PitchPage />} />
                <Route path="/email" element={<EmailPage />} />
                <Route path="/tshirt" element={<TshirtGalleryPage />} />
                <Route path="/links" element={<LinksPage />} />
                <Route path="/linksvideo" element={<VideoPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/cittadino" element={<CittadinoPage />} />
                <Route path="/about" element={<AllAboutUsPage />} />
                <Route path="/recap" element={<RecapPage />} />
                <Route path="/doposcuola" element={<DoposcuolaPage />} />
                <Route path="/artistigianato" element={<ArtistigianatoPage />} />
                <Route path="/podcast" element={<PodcastPage />} />
                <Route path="/chiantibanca" element={<ChiantiBancaPage />} />
                <Route path="/generazioni" element={<GenerazioniPage />} />
                <Route path="/mentor" element={<MentorPage />} />
                <Route path="/archivio" element={<ArchivioDigitalePage />} />
                <Route path="/social" element={<SocialPage />} />
                <Route path="/strategia" element={<StrategiaPage />} />
                <Route path="/crowdfunding" element={<CrowdfundingPage />} />
                <Route path="/angels" element={<AngelsPage />} />
                <Route path="/utility" element={<UtilityPage />} />
              </Routes>
              <Footer />
              <HostessChat />
              <LiveDonationToast />
              <SponsorTicker />
              <PwaInstallBanner />
              <FloatingQuiz />
            </div>
          </>
        } />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
